import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import Portal from '../portal';
import Icon from '../icon';
import './style.scss';

export default class Popup extends React.Component {

	static propTypes = {
		id: PropTypes.string, // необязателен, id элемента портала (нужно иногда)
		className: PropTypes.string, // необязателен, css-класс для содержимого окна
		header: PropTypes.any, // необязателен, заголовок окна, строка или JSX
		scrollable: PropTypes.bool,
		portalClassName: PropTypes.string, // необязателен, css-класс для всего портала
		onClose: PropTypes.func, // callback при закрытии
		instance: PropTypes.func, // функция, которой в аргументе передастся объект { close }, где close - это метод, закрывающий попап
		showCloseButton: PropTypes.bool, // boolean, показывать ли кнопку закрытия
		canClose: PropTypes.bool, // boolean, может ли закрыться попап
		target: PropTypes.any, // элемент, в который будет вставлен портал
		contentRef: PropTypes.func, // ref на контейнер содержимого
		width: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]), // ширина попапа
		height: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]), // высота попапа
	};
	
	static defaultProps = {
		id: 'ui-popup',
		portalClassName: '',
		className: '',
		showCloseButton: true,
		scrollable: true,
		canClose: true,
	};

	mouseInside = false;

	constructor(props) {
		super(props);
		if (props.instance) {
			props.instance({
				close: this.close,
			});
		}
	}
	
	onContentMount = el => {
		this.contentDiv = el;
		if (this.props.contentRef) this.props.contentRef(el);
	};
	
	close = () => {
		if (this.props.canClose && this.props.onClose) this.props.onClose();
	};

	onMouseDown = e => {
		this.mouseInside = this.contentDiv && !this.contentDiv.contains(e.target);
	};

	onMouseUp = e => {
		if (this.contentDiv && !this.contentDiv.contains(e.target) && this.mouseInside) {
			this.close();
		}
		this.mouseInside = false;
	};
	
	render() {
		const { id, children, header, target, canClose, portalClassName, scrollable, className, showCloseButton, width, height } = this.props;

		const style = { width, height };
		
		return <Portal portalId={id} target={target} className={'ui-popup-portal ' + portalClassName + (scrollable ? '' : ' not-scrollable')}
		               onMouseDown={this.onMouseDown}
		               onMouseUp={this.onMouseUp}>
			<div className="ui-popup-content-wrapper" ref={this.onContentMount}>
				{header && <div className="ui-popup-header">{header}</div>}
				{canClose && showCloseButton && <FontAwesomeIcon icon={faTimes} className="ui-popup-close-btn" onClick={this.close}/>}
				<div className={'ui-popup-content ' + className} style={style}>
					{children}
				</div>
			</div>
		</Portal>;
	}
	
}
